import { StorefrontSortingSetting } from '@rediredi/types'
import en from '~/lang/en/main.json'
import es from '~/lang/es/main.json'
import ptBR from '~/lang/pt-BR/main.json'
import enXX from '~/lang/xxa/main.json'
import { StorefrontStore } from '~/types/store'

const LANG_MAP = {
  en,
  es,
  'en-XX': enXX,
  'pt-BR': ptBR,
}

export const SORTING_MAP: Record<StorefrontSortingSetting, string> = {
  [StorefrontSortingSetting.AlphabeticalAToZ]: 'title:asc',
  [StorefrontSortingSetting.AlphabeticalZToA]: 'title:desc',
  [StorefrontSortingSetting.PriceLowToHigh]: 'price:asc',
  [StorefrontSortingSetting.PriceHighToLow]: 'price:desc',
  [StorefrontSortingSetting.MostRecent]: 'userUpdatedAt:desc',
}

export default defineNuxtPlugin(async (nuxtApp) => {
  const url = useRequestURL()
  const config = useRuntimeConfig()
  const host = config.public.CLIENT_HOST || url.host
  const route = useRoute()

  const salespersonHandle = route.params.salesperson

  const qs = new URLSearchParams(
    salespersonHandle ? { salespersonHandle: salespersonHandle.toString() || '' } : {},
  )

  // @ts-ignore
  const globalStore = useGlobalStore(nuxtApp.$pinia)
  // @ts-ignore
  const itemsStore = useItemsStore(nuxtApp.$pinia)
  const { data } = await useApiFetch<StorefrontStore>(`/stores/storefront/${host}?${qs}`)

  const store = data.value

  if (store) {
    useState('currentStore', () => store)
    useState('theme', () => store?.themeColorScheme)
    globalStore.store = store
    globalStore.$state.store = store
    const sorting =
      SORTING_MAP[
        globalStore.store.storefrontPreferences?.itemsSorting ||
          StorefrontSortingSetting.AlphabeticalAToZ
      ] || StorefrontSortingSetting.AlphabeticalAToZ
    const [sortBy, sortOrder] = sorting.split(':')
    itemsStore.sortBy = sortBy
    itemsStore.order = sortOrder as 'asc' | 'desc'
    const locale = globalStore.store.locale as string
    // @ts-ignore
    const messages = LANG_MAP[locale]
    // @ts-ignore
    nuxtApp.$i18n.setLocaleMessage(locale, messages)
    // @ts-ignore
    nuxtApp.$i18n.locale.value = locale
    return
  }

  navigateTo('https://rediredi.com/br/catalogo-online/', { external: true })
})
